// Respaldo bilingue de los avisos del selector de ubicacion, que usan tanto el
// `LocationPicker` del perfil como el modal de ubicacion de una publicacion.
//
// POR QUE EXISTE: son el `||` que cubre una clave del esquema remoto
// (LB0392, LB0418, LB0456, ER0053) que hoy no llega, y estaban escritos solo en
// espanol. El esquema SIEMPRE gana cuando publique las suyas.

import { normalizeInterfaceLanguage } from "../interfaceLanguage";

const locationMessages = {
  es: {
    writeLocation: "Escribe una ubicación",
    selectFromList: "Selecciona una opción de la lista",
    saveLocationFailed: "No se pudo guardar la ubicación",
    suggestionsFailed: "Error al obtener recomendaciones de ubicación.",
  },
  en: {
    writeLocation: "Type a location",
    selectFromList: "Select an option from the list",
    saveLocationFailed: "Could not save the location",
    suggestionsFailed: "Could not get location suggestions.",
  },
};

export const getLocationMessages = (language) =>
  locationMessages[normalizeInterfaceLanguage(language)];
